import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
    isCollapsed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    toggleIsCollapsed(): void {
        this.isCollapsed$.next(!this.isCollapsed$.value);
    }
}
